module.exports = __webpack_public_path__ + "img/icon-sb-mattress-firm-color-boutique-36.2c60af6.svg";